export default "__VITE_ASSET__DhoVSxWC__"